import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import API_BASE_URL from "../apiConfig";

const PaymentCallback = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(null); // null means status is still loading
  const [error, setError] = useState("");
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [renewDate, setRenewDate] = useState(null);
  const navigate = useNavigate(); // Initialize the navigate function

  const fetchSubscriptionStatus = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setError("User is not authenticated. Please log in.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/user-subscriptions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (response.ok) {
        if (result.success === true) {
          setIsSubscribed(true);
          setRenewDate(result.subscription.next_billing_date);
        } else {
          setIsSubscribed(false);
        }
      } else {
        setError(result.message || "Failed to fetch subscription status.");
      }
    } catch (error) {
      console.error("Error fetching subscription status:", error);
      setError("An error occurred: " + error.message);
    }
  };

  useEffect(() => {
    const getUrlParam = (param) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    };

    const handlePaymentCallback = async () => {
      const token_paypal = getUrlParam("token");

      if (token_paypal) {
        console.log("Token from URL:", token_paypal);
        const token = localStorage.getItem("token");

        if (!token) {
          setMessage("User is not authenticated. Please log in.");
          setLoading(false);
          return;
        }

        try {
          const paymentData = {
            token: token_paypal,
          };

          const response = await axios.post(
            `${API_BASE_URL}/api/user/subscriptions/paypal`,
            paymentData, // Pass the payload here
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          console.log("API response:", response.data);
                    
          if (response.data.success) {
            // Payment successful, fetch subscription status
            fetchSubscriptionStatus(); 
            // Navigate to the /premium-wallet page
            window.location.href = "/premium-wallet";  
          } else {
            console.error("Payment failed:", response.data);
            alert("Payment processing failed. Please try again.");
          }
        } catch (error) {
          console.error("API call error:", error.response || error.message || error);
          alert("An error occurred while processing your payment. Please try again.");
        }
      } else {
        console.warn("No token found in the URL.");
      }
    };

    handlePaymentCallback();
  }, [navigate]); // Add navigate to dependency array

  return (
    <>
      {loading && <div>Loading...</div>}
      {message && <div>{message}</div>}
      {error && <div>{error}</div>}
      {isSubscribed === false && <div>You are not subscribed yet.</div>}
      {isSubscribed && <div>Your subscription is active. Renew Date: {renewDate}</div>}
    </>
  );
};

export default PaymentCallback;
